export const setCookie = (name: string, value: string, days: number) => {
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = `; expires=${date.toUTCString()}`;
        document.cookie = `${name}=${value || ""}${expires}; path=/`;
    }
};

export const getCookieValue = (name: string) =>
    document?.cookie?.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop() || "";

export const getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    return parts.length === 2 ? parts.pop()?.split(";").shift() : "";
};
